//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import Table from '@/components/FilterTable/Table.vue';

const DEFAULT_FORMAT = (value) => (value ? value : 'N/A')

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
      Table,
  },
  mounted: function () {
    BackendServices.getRetailers().then(response => {
      let retailerColumns = response.data.filter((retailer) => (retailer.name !== "Sem Categorização")).map((retailer, index) => {
        return [
          {
            name: `name-retailer-${index + 1}`,
            required: false,
            label: `Nome ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.name),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `sku-retailer-${index + 1}`,
            required: false,
            label: `Código Interno ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.sku),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `category-code-${index + 1}`,
            required: false,
            label: `Código Categoria ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.category_code),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `category-description-${index + 1}`,
            required: false,
            label: `Descrição Categoria ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.category_description),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `subcategory-code-${index + 1}`,
            required: false,
            label: `Código Subcategoria ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.subcategory_code),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `subcategory-description-${index + 1}`,
            required: false,
            label: `Descrição Subcategoria ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.subcategory_description),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `brand-${index + 1}`,
            required: false,
            label: `Marca ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.brand),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: `subbrand-${index + 1}`,
            required: false,
            label: `Submarca ${retailer.name}`,
            group: retailer.name,
            align: "left",
            field: (row) => (row.product_retailer_infos.filter((retailerInfo) => (retailerInfo.retailer_id === retailer.id))[0]?.sub_brand),
            format: DEFAULT_FORMAT,
            sortable: false,
          }
        ]
      })
      this.columns = [
        {
          name: "ean",
          required: true,
          label: "EAN",
          align: "left",
          field: (row) => (row.ean),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "name",
          align: "left",
          label: "Nome",
          field: (row) => (row.name),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "is-innovation",
          align: "left",
          label: "Produto Inovação",
          field: (row) => (row.is_innovation),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "is-renovation",
          align: "left",
          label: "Produto Renovação",
          field: (row) => (row.is_renovation),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        ...retailerColumns.flat()
      ]
    })
  },
  data: () => ({
    separator: "horizontal",
    columns: []
  }),
  methods: {
    renderRightSide: function(event) {
        this.$emit("clicked-row", {...event});
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event)
    }
  },
};
